export default "__VITE_ASSET__CkV08tSO__"